import IconLink from '~/themes/base/components/molecule/IconLink'

export default {
  extends: IconLink,
}
